import { useTranslation } from 'react-i18next';
import { Badge } from '@monksflow/monks-ui';

interface Props {
  version: number;
}

/**
 * The `v{n}` outline badge shown beside an artifact's subtext in the Library
 * card and the artifact picker. Centralized so the two surfaces can't drift —
 * the version is often the only thing distinguishing otherwise-identical
 * artifacts (same title + context). Callers decide WHEN to render it (e.g. the
 * card hides it for file kinds, which a filename already disambiguates).
 */
export function ArtifactVersionBadge(props: Props) {
  const { t } = useTranslation('common');

  return (
    <Badge variant="outline" roundness="full" className="shrink-0 py-0">
      {t('artifact.artifactVersionBadge.version', { version: props.version })}
    </Badge>
  );
}
